<template>
  <div class="messages-view">
    <h1>SPOT Device Messages</h1>

    <!-- Date range dropdown -->
    <select v-model="timeframe" @change="updateDateRange">
      <option value="1h">Last 1 Hour</option>
      <option value="24h">Last 24 Hours</option>
      <option value="7d">Last 7 Days</option>
      <option value="1m">Last 30 Days</option>
      <option value="custom">Custom Date Range</option>
    </select>

    <!-- Custom date range inputs (only visible if "custom" is selected) -->
    <div v-if="timeframe === 'custom'">
      <input type="date" v-model="customStartDate" />
      <input type="date" v-model="customEndDate" />
      <button @click="updateCustomDateRange">Update</button>
    </div>

    <div v-if="messages.length">
      <ul>
        <li v-for="(message, index) in messages" :key="index">
          <strong>{{ message.messengerName }}</strong>
          <p><strong>Message:</strong> {{ message.messageContent }}</p>
          <p><strong>Message Type:</strong> {{ message.messageType }}</p>
          <p><strong>Time:</strong> {{ message.dateTime }}</p>
          <p>
            <strong>Location:</strong> Lat: {{ message.latitude }}, Lon:
            {{ message.longitude }}
          </p>
        </li>
      </ul>
    </div>
    <div v-else>
      <p>No messages available for the selected timeframe.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      messages: [],
      feedId: '0oSnR9sojRxyk0QcoWjKKHgYfF0vyUYui', // Replace with your Feed ID
      timeframe: '24h',
      startDate: '2023-11-24T00:00:00-0000', // Default 24h
      endDate: '2023-11-25T00:00:00-0000', // Default 24h
      customStartDate: '',
      customEndDate: '',
    }
  },
  mounted() {
    this.fetchMessages()
  },
  methods: {
    async fetchMessages() {
      const { feedId, startDate, endDate } = this
      const url = `https://api.findmespot.com/spot-main-web/consumer/rest-api/2.0/public/feed/${feedId}/message.json?startDate=${startDate}&endDate=${endDate}`

      try {
        const response = await axios.get(url)
        this.messages = response?.data?.feedMessageResponse?.messages || []
      } catch (error) {
        console.error('Error fetching SPOT messages:', error)
      }
    },

    updateDateRange() {
      const now = new Date()
      if (this.timeframe === '1h') {
        this.startDate = new Date(now - 60 * 60 * 1000).toISOString() // 1 hour ago
      } else if (this.timeframe === '24h') {
        this.startDate = new Date(now - 24 * 60 * 60 * 1000).toISOString() // 24 hours ago
      } else if (this.timeframe === '7d') {
        this.startDate = new Date(now - 7 * 24 * 60 * 60 * 1000).toISOString() // 7 days ago
      } else if (this.timeframe === '1m') {
        this.startDate = new Date(now - 30 * 24 * 60 * 60 * 1000).toISOString() // 30 days ago
      }
      this.fetchMessages()
    },

    updateCustomDateRange() {
      if (this.customStartDate && this.customEndDate) {
        this.startDate = `${this.customStartDate}T00:00:00-0000`
        this.endDate = `${this.customEndDate}T23:59:59-0000`
        this.fetchMessages()
      }
    },
  },
}
</script>
